import httpClient from './httpClient';

const getMotivos = () => {    
    return httpClient.get('/AppPedido/motivosRechazo');
};

export default getMotivos;